import { mapMutations, mapGetters } from 'vuex';

export default {
  methods: {
    ...mapMutations({
      _setDetails: 'groupDetails/setDetails',
      _setEditable: 'groupDetails/setEditingDetails',
    }),
  },
  computed: {
    ...mapGetters({
      _getDetails: 'groupDetails/getDetails',
      _getEditable: 'groupDetails/getEditingDetails',
    }),
    details: {
      get() {
        const details = this._getDetails;
        if (!details.address) {
          details.address = {};
        }
        return details;
      },
      set(val) {
        if (typeof val === 'string') {
          this._setDetails(val.toLowerCase());
        } else {
          this._setDetails(val);
        }
      },
    },
    editable: {
      get() {
        return this._getEditable;
      },
      set(val) {
        this._setEditable(val);
      },
    },
  },
};
